import * as types from "../actions/types";

const initialState = {
  areas: [],
  loading: false
};

export default function areas(state = initialState, action) {
  switch (action.type) {
    case types.SET_AREAS_DATA:
      return {
        ...state,
        areas: action.payload
      };
    
    case types.SET_AREAS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
  
    default:
      return state;
  }
}

